import React from 'react';
import type {TableColumnsType} from 'antd';
import {Table} from 'antd';
import { VoucherClearingLogType } from '../graphql/types/VoucherClearingLogType';

interface SettlementVoucherRowProps {
    rowData: VoucherClearingLogType[];
    onSelectChange?: (selectedRowKeys: React.Key[], selectedRows: VoucherClearingLogType[]) => void;
    selectedRowKeys?: React.Key[];
    loading?: boolean;
}

export const VoucherClearingLogColumns: React.FC<SettlementVoucherRowProps> = ({
    rowData, 
    loading
}) => {

    const voucherClearingLogColumns: TableColumnsType<VoucherClearingLogType> = [
        {
            title: 'Tracking',
            dataIndex: 'businessId',
            key: 'businessId',
            width:120,
            align: 'left',
        },
        {
            title: '清分ID',
            dataIndex: 'clearingId',
            key: 'clearingId',
            minWidth:85,
            align: 'left',
        },
        {
            title: '定价ID',
            dataIndex: 'pricingId',
            key: 'pricingId',
            minWidth:85,
            align: 'left',
        },
        {
            title: '任务ID',
            dataIndex: 'reRunTaskId',
            key: 'reRunTaskId',
            minWidth:85,
            align: 'left',
        },
        {
            title: '操作类型',
            dataIndex: 'logEvent',
            key: 'logEvent',
            minWidth:90,
            align: 'left',
        },
         {
            title: '描述',
            dataIndex: 'description',
            key: 'description',
            width:100,
            align: 'left',
        },
        {
            title: '快照数据',
            dataIndex: 'snapshotDataJson',
            key: 'snapshotDataJson',
            render: (snapshotDataJson) => {
                try {
                    const formattedJson = typeof snapshotDataJson === 'string' 
                        ? JSON.stringify(JSON.parse(snapshotDataJson), null, 2)
                        : JSON.stringify(snapshotDataJson, null, 2);
                    return (
                        <pre className="whitespace-pre-wrap break-words max-h-[150px] overflow-y-auto p-2 text-sm">
                            {formattedJson}
                        </pre>
                    );
                } catch (e) {
                    return <span className="inline-block px-2 py-1">{snapshotDataJson}</span>;
                }
            },
        },
        {
            title: '创建时间',
            dataIndex: 'createdAt',
            key: 'createdAt',
            minWidth:90,
            align: 'left',
        }
    ];

    return (
        <Table
            rowKey={(record) => record.id}
            columns={voucherClearingLogColumns}
            dataSource={rowData}
            scroll={{x: 1950}}
            tableLayout="auto"
            size="middle"
            className="mb-4"
            pagination={false}
            loading={loading}
        />
    );
};